import { findEssenceAbilityForSkill, findSkillCatalogEntry } from '@sorrem/shared';
import classnames from 'classnames';
import { formatBindingLabel, useInputBindings } from '@sorrem-client/ui/hooks';
import styles from './SkillHotkeyHint.module.scss';

interface SkillHotkeyHintProps {
    readonly className?: string;
    /** The skill waiting for an action slot; the hint hides while null. */
    readonly skillId: string | null;
}

/** The callout over the loadout while a skill waits for the player to pick its action slot. */
export function SkillHotkeyHint({ className, skillId }: SkillHotkeyHintProps): JSX.Element {
    const { bindings } = useInputBindings();
    const cancelKey = formatBindingLabel(bindings, 'open-menu');
    const name = skillId === null ? '' : findEssenceAbilityForSkill(skillId)?.name ?? findSkillCatalogEntry(skillId)?.name ?? skillId;

    return (
        <p className={classnames(styles.skillHotkeyHint, skillId !== null && styles.visible, className)} role='status'>
            {skillId !== null && (
                <>
                    Click an action slot or press its key to put <strong>{name}</strong> there. {cancelKey} cancels.
                </>
            )}
        </p>
    );
}
